import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "../../../constants";

export const getCreatedScheduledById = createAsyncThunk(
  "package/getCreatedScheduledById",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await fetch(
        `${apiUrl}/get_schedule_history?ds_id=${data.id}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Fetching scheduled deliveries failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const createdScheduledDeliveriesByIdSlice = createSlice({
  name: "scheduledDeliveriesById",
  initialState: {
    deliveries: [],
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    clearScheduledDeliveriesState: (state) => {
      state.deliveries = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCreatedScheduledById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getCreatedScheduledById.fulfilled, (state, action) => {
        state.status = "success";
        state.deliveries = action.payload.schedule_history;
      })
      .addCase(getCreatedScheduledById.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.deliveries = [];
      });
  },
});

export const { clearScheduledDeliveriesState } =
  createdScheduledDeliveriesByIdSlice.actions;
export default createdScheduledDeliveriesByIdSlice.reducer;
